import {useEffect, useState} from "react";
import { Modal, Input, Form, Col, Divider, Row, Button, DatePicker, Select, Switch } from 'antd';

import {setProductDataAction} from "../store/actions/productActions";
import {useDispatch, useSelector} from "react-redux";
import ProductService from "../Api/ProductService";
import ProductData from "../data/ProductData";


function CrmProductModalFull(props) {



    const { TextArea } = Input;
    const { Option } = Select;
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    let id = props.id;

    const defaultProductData = ProductData.getDefaultProductData();
    const [product, setProduct] = useState(defaultProductData);

    const data = useSelector(state => state.productState);

    const [isModalOpen, setIsModalOpen] = useState(false);



    useEffect(() => {
        if (id) {
            setProduct(data.productData);
            setIsModalOpen(true);
            getProduct(id);

        }
    }, [id])



    const showModal = () => {
        setProduct(defaultProductData);
        getProduct(false)
        //dispatch(setProductDataAction(false));
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };


    async function editProduct() {
        const response = await ProductService.edit(product);
        if (response.statusText === 'OK') {
            alert('Продукт змінено');

        } else {
            alert(response.data.message);
        }
    }

    async function addNewProduct(e) {
        e.preventDefault();

        const response = await ProductService.create(product);

        if (response.data.id) {
            getProduct(response.data.id);
            console.log(response.data.id);

        } else {
            console.log('error');
        }

    }


    async function getProduct(id) {
        let response = false;
        if (id) {
            response = await ProductService.getOne(id);

        } else {
            response = defaultProductData;
        }

        onFill(response);


        setProduct({
            id: response.id,
            name: response.name ?? '',
            group_id: response.group_id ?? '',
            description: response.description ?? '',
            meta_description: response.meta_description ?? '',
            quantity_pack: response.quantity_pack ?? '',
            barcode: response.barcode ?? '',
            quantity: response.quantity ?? '',
            price: response.price ?? '',
            unit: response.unit ?? '',
            type_id: response.type_id ?? '',
            warehouse_id: response.warehouse_id ?? '',
            manufacturer_id: response.manufacturer_id ?? '',
            comment: response.comment ?? '',
            site_on: response.site_on ?? '' ,
            code: response.code ?? '',
            status: response.status ?? '',
            user_id: response.user_id ?? '',
            suitability: response.suitability ?? '2000-01-01',
        });
        return response;
    }

    const onFill = (data) => {
        form.setFieldsValue({
            id: data.id,
            name: data.name ?? '',
            group_id: data.group_id ?? '',
            description: data.description ?? '',
            meta_description: data.meta_description ?? '',
            quantity_pack: data.quantity_pack ?? '',
            barcode: data.barcode ?? '',
            quantity: data.quantity ?? '',
            price: data.price ?? '',
            unit: data.unit ?? '',
            type_id: data.type_id ?? '',
            warehouse_id: data.warehouse_id ?? '',
            manufacturer_id: data.manufacturer_id ?? '',
            comment: data.comment ?? '',
            site_on: data.site_on ?? '' ,
            code: data.code ?? '',
            status: data.status ?? '',
            user_id: data.user_id ?? '',
            suitability: data.suitability ?? '',
        });
    };


    return (
        <>
            <Button type="primary" onClick={showModal}>Add product</Button>

            <Modal title="Product"
                   open={isModalOpen}
                   onOk={handleOk}
                   onCancel={handleCancel}
                   width={1500}
            >
                {console.log(product)}

                <Form form={form}>


                    <Divider orientation="left">{product.id}</Divider>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <Form.Item label="Name" name="name"
                                       rules={[{required: true, message: 'Please input your name!'}]}>
                                <Input onChange={e => setProduct({...product, name: e.target.value})}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <Form.Item name="group_id" label="Category">
                                <Select allowClear onChange={e => console.log({...product, group_id: e})}>
                                    <Option value="1">category 1</Option>
                                    <Option value="2">category 2</Option>
                                    <Option value="3">category 3</Option>
                                </Select>
                            </Form.Item>

                        </Col>
                        <Col className="gutter-row" span={6}>
                            <Form.Item label="Barcode" name="barcode">
                                <Input onChange={e => setProduct({...product, barcode: e.target.value})}/>
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={16}>
                        <Col className="gutter-row" span={6}>
                            <Form.Item label="Price" name="price">
                                <Input onChange={e => setProduct({...product, price: e.target.value})}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <Form.Item label="Quantity" name="quantity">
                                <Input onChange={e => setProduct({...product, quantity: e.target.value})}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <Form.Item label="Quantity pack" name="quantity_pack">
                                <Input onChange={e => setProduct({...product, quantity_pack: e.target.value})}/>
                            </Form.Item>
                        </Col>

                        <Col className="gutter-row" span={6}>
                            <Form.Item label="Unit" name="unit">
                                <Select onChange={e => setProduct({...product, unit: e})}>
                                    <Select.Option value="0">-</Select.Option>
                                    <Select.Option value="1">Одитиць</Select.Option>
                                    <Select.Option value="2">Штук</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={16}>
                        <Col className="gutter-row" span={8}>
                            <Form.Item label="Description" name="description">
                                <TextArea rows={4}
                                          onChange={e => setProduct({...product, description: e.target.value})}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={8}>
                            <Form.Item label="Meta Description" name="meta_description">
                                <TextArea rows={4}
                                          onChange={e => setProduct({...product, meta_description: e.target.value})}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={8}>
                            <Form.Item label="Comment" name="comment">
                                <TextArea rows={4} onChange={e => setProduct({...product, comment: e.target.value})}/>
                            </Form.Item>
                        </Col>

                    </Row>


                    <Row gutter={16}>
                        <Col className="gutter-row" span={5}>
                            <Form.Item label="Manufacturer" name="manufacturer_id">
                                <Select onChange={e => setProduct({...product, manufacturer_id: e})}>
                                    <Select.Option value="0">-</Select.Option>
                                    <Select.Option value="1">Виробник 1</Select.Option>
                                    <Select.Option value="2">Виробник 2</Select.Option>
                                    <Select.Option value="3">Виробник 3</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        {/* <Col className="gutter-row" span={4}>
                            <Form.Item label="Srok gd" name="suitability">
                                <DatePicker onChange={e => console.log(e)}/>
                            </Form.Item>
                        </Col> */}
                        <Col className="gutter-row" span={5}>
                            <Form.Item label="Status" name="status">
                                <Select onChange={e => setProduct({...product, status: e})}>
                                    <Select.Option value="0">-</Select.Option>
                                    <Select.Option value="1">Активне</Select.Option>
                                    <Select.Option value="2">Контент</Select.Option>
                                    <Select.Option value="3">Вимкнене</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={5}>
                            <Form.Item label="Type" name="type_id">
                                <Select onChange={e => setProduct({...product, type_id: e})}>
                                    <Select.Option value="0">-</Select.Option>
                                    <Select.Option value="1">тип 1</Select.Option>
                                    <Select.Option value="2">Тип 2</Select.Option>
                                    <Select.Option value="3">Тип 3</Select.Option>
                                    <Select.Option value="4">Тип 4</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>


                        {/*
                        <Col className="gutter-row" span={2}>
                            <Form.Item label="On site" name="site_on">
                                <Switch defaultChecked />
                            </Form.Item>
                        </Col>
                        */}
                    </Row>

                {product.id > 0
                    ? <Button type="primary" onClick={editProduct}>edit</Button>
                    : <Button type="primary" onClick={addNewProduct}>create</Button>
                }
                </Form>

            </Modal>
        </>
    );
}
export default CrmProductModalFull;
